import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import { AD_PLAN_AUTORESPONDERS } from "constants";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import AutoresponderList from "./AutoresponderList";

export default () => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [createAutoresponderModal, setCreateAutoresponderModal] =
    useState(false);
  const [disabledModal, setDisabledModal] = useState(false);

  const UserProperties = createSelector(
    (state) => state.User,
    (user) => ({
      profileData: user.profileData,
    })
  );

  const { profileData } = useSelector(UserProperties);

  const limit = 10;

  // Fetch data
  const GET_RESPONDER_LIST_DATA = gql`
    query GetResponderListData($page: Int!, $limit: Int!) {
      responderListData(page: $page, limit: $limit) {
        responders {
          id
          name
          status
          over_limit
          messages {
            id
          }
          leads {
            id
          }
          lists {
            id
          }
        }
        numOfResults
      }
    }
  `;

  const { data, error, refetch } = useQuery(GET_RESPONDER_LIST_DATA, {
    variables: {
      page,
      limit,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching responder list data", error);
    captureException(error);
  }

  const onOpenClick = (id) => {
    navigate(`/autoresponder?id=${id}`);
  };

  // handle Create autoresponder modal
  const openCreateAutoresponderModal = () => {
    if (profileData.adPlan < AD_PLAN_AUTORESPONDERS) {
      setDisabledModal(true);
      return;
    }

    setCreateAutoresponderModal(true);
  };

  const closeCreateAutoresponderModal = () => {
    setCreateAutoresponderModal(false);
  };

  const onCloseDisabledModal = () => {
    setDisabledModal(false);
  };

  // handle Pagination
  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  //console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="435px" />
        </LoadingBox>
      )}
      {data && (
        <AutoresponderList
          data={data}
          onOpenClick={onOpenClick}
          openCreateAutoresponderModal={openCreateAutoresponderModal}
          closeCreateAutoresponderModal={closeCreateAutoresponderModal}
          createAutoresponderModal={createAutoresponderModal}
          refetch={refetch}
          disabledModal={disabledModal}
          onCloseDisabledModal={onCloseDisabledModal}
          limit={limit}
          page={page}
          paginate={paginate}
        />
      )}
    </>
  );
};
